import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { ChargingStationCommandResult, getChargingStationCommandResults } from '@infuse/api/cpms/operator';

export interface GroupConfiguration {
  variable: {
    name: string;
  };
  variableAttributes: [
    {
      value: string;
      attributeType: string;
      difference?: boolean;
    }
  ];
}

export const useOcppCommandResults = () => {
  const apiCorrelationToken = ref<string>();

  const query = useQuery<ChargingStationCommandResult>({
    queryKey: ['chargingStationCommandResult', apiCorrelationToken],
    enabled: !!apiCorrelationToken.value,
    queryFn: () => getChargingStationCommandResults({ id: apiCorrelationToken.value }),
    gcTime: 0, // Do not cache in background
    staleTime: 0, // Consider data immediately stale
    refetchOnMount: true, // Always refetch on mount
    refetchOnWindowFocus: true,
    refetchOnReconnect: true
  });

  return {
    ...query,
    apiCorrelationToken
  };
};
